import { logger } from "@/utils/logger";
import { timeToMinutes } from "./helpers";
function generateUniqueId() {
    return `vehicle_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
}
function findSuitableVehicleByType(vehicles, service, requiredType) {
    const serviceStartTime = timeToMinutes(service.baslangic);
    const newDirection = service.yon;
    return vehicles.find((vehicle) => {
        if (vehicle.type !== requiredType) {
            return false;
        }
        const assignments = vehicle.assignments;
        if (!assignments || assignments.length === 0)
            return true;
        const lastAssignment = assignments[assignments.length - 1];
        const lastServiceEndTime = lastAssignment.endTime;
        const lastDirection = lastAssignment.service.yon;
        if (serviceStartTime < lastServiceEndTime) {
            return false;
        }
        return newDirection !== lastDirection;
    });
}
function assignVehicleToService(vehicle, service, assignments) {
    const startTime = timeToMinutes(service.baslangic);
    const duration = service.sure || 45;
    const endTime = startTime + duration;
    const assignment = {
        vehicle_id: vehicle.id,
        service_id: service.id,
        service: service,
        startTime: startTime,
        endTime: endTime,
    };
    vehicle.assignments.push(assignment);
    assignments.push(assignment);
}
/** Vuex kaynak: vehicleAssignment.js — micro-6-2/6-3 paylaşımlı algoritma */
export function assignVehiclesToServices(services) {
    const startTime = Date.now();
    if (!Array.isArray(services)) {
        logger.error("Geçersiz servis verisi:", services);
        return { vehicles: [], assignments: [] };
    }
    if (services.length > 1000) {
        logger.warn(`Çok sayıda servis (${services.length}) - performans için 1000 ile sınırlandırılıyor`);
        services = services.slice(0, 1000);
    }
    logger.debug(`Araç ataması yapılıyor: ${services.length} servis`);
    const servicesByType = new Map();
    for (const service of services) {
        const type = service.arac_tipi || service.original_arac_tipi || "SOLO";
        if (!servicesByType.has(type)) {
            servicesByType.set(type, []);
        }
        servicesByType.get(type).push({
            ...service,
            arac_tipi: type,
        });
    }
    logger.debug("Araç tiplerine göre gruplandırılmış servisler:", Array.from(servicesByType.keys()).map((type) => `${type}: ${servicesByType.get(type).length} servis`));
    const vehicles = [];
    const assignments = [];
    for (const [vehicleType, typeServices] of servicesByType.entries()) {
        logger.debug(`${vehicleType} tipi için araç ataması yapılıyor (${typeServices.length} servis)`);
        typeServices.sort((a, b) => timeToMinutes(a.baslangic) - timeToMinutes(b.baslangic));
        for (const service of typeServices) {
            let assignedVehicle = findSuitableVehicleByType(vehicles, service, vehicleType);
            if (!assignedVehicle) {
                assignedVehicle = {
                    id: generateUniqueId(),
                    type: vehicleType,
                    assignments: [],
                };
                vehicles.push(assignedVehicle);
            }
            assignVehicleToService(assignedVehicle, service, assignments);
        }
    }
    logger.debug(`Atama tamamlandı: ${vehicles.length} araç, ${assignments.length} atama (${Date.now() - startTime}ms)`);
    return { vehicles, assignments };
}
/** Backend path-cover `arac_id` değerlerinden araç/atama üretir (greedy yeniden atama yok). */
export function assignVehiclesFromAracIds(services) {
    if (!Array.isArray(services) || services.length === 0) {
        return { vehicles: [], assignments: [] };
    }
    const byVehicle = new Map();
    const assignments = [];
    for (const service of services) {
        const aracId = Number(service.arac_id);
        if (!Number.isFinite(aracId) || aracId <= 0) {
            logger.warn("arac_id eksik/geçersiz, atama atlandı:", service?.id);
            continue;
        }
        const type = service.arac_tipi || service.original_arac_tipi || "SOLO";
        if (!byVehicle.has(aracId)) {
            byVehicle.set(aracId, {
                id: `vehicle_pc_${aracId}`,
                type,
                assignments: [],
            });
        }
        const vehicle = byVehicle.get(aracId);
        if (!vehicle.type && type)
            vehicle.type = type;
        const startTime = timeToMinutes(service.baslangic);
        const duration = Number(service.sure) || 45;
        let endTime = startTime + duration;
        if (service.bitis) {
            const bitisDk = timeToMinutes(service.bitis);
            if (Number.isFinite(bitisDk) && bitisDk >= startTime) {
                endTime = bitisDk;
            }
        }
        const assignment = {
            vehicle_id: vehicle.id,
            service_id: service.id,
            service: { ...service, arac_tipi: type },
            startTime,
            endTime,
            arac_id: aracId,
        };
        vehicle.assignments.push(assignment);
        assignments.push(assignment);
    }
    const vehicles = Array.from(byVehicle.entries())
        .sort((a, b) => a[0] - b[0])
        .map(([, v]) => v);
    return { vehicles, assignments };
}
export function servicesHaveAracIds(services) {
    if (!Array.isArray(services) || services.length === 0)
        return false;
    return services.every((s) => s?.arac_id != null && s.arac_id !== "" && Number(s.arac_id) > 0);
}
